import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import dynamic from 'next/dynamic'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import CollectData from './components/CollectData'
import Hero from './components/Hero'

import AdditionalResources from './components/AdditionalResources'

import ogImageJpeg from './assets/OgEngineering.jpeg'

const CollectDataDetails = dynamic(() => import(`./components/CollectDataDetails`))
const PowerYourApps = dynamic(() => import(`./components/PowerYourApps`))
const UnderTheHood = dynamic(() => import(`./components/UnderTheHood`))
const QueryData = dynamic(() => import(`./components/QueryData`))

const TestimonialSlider = dynamic(() => import(`@segment/templates/TestimonialSlider`))
const GettingStarted = dynamic(() => import(`@segment/templates/GettingStarted`))

const EngineeringView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Engineering | Twilio Segment for Engineering Teams"
        pageDescription="Use one API to collect analytics data, across any platform. We have SDKs for JavaScript, iOS, Android, and 20+ server-side languages."
        pageOG={ogImageJpeg}
        themeColor={theme.palette.brand.darkAcai[800]}
      >
        <Navigation />
        <Hero />
        <Main>
          <CollectData />
          <CollectDataDetails />
          <PowerYourApps />
          <QueryData />
          <UnderTheHood />
          <AdditionalResources />
          <TestimonialSlider />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default EngineeringView
